import axios from "axios";
import { DRIVE_FOLDER_SEARCH_TYPE } from "@constants";
import { handleActions, createAction } from "redux-actions";
import {
    createDriveFolderAPI,
    getDrivesListAPI,
    getFoldersListAPI,
    getDetailDriveFolderAPI,
    setFolderInfoAPI,
    deleteFolderAPI,
    moveFolderAPI,
} from "./apis/virtureFolder";

//action type
const GET_FOLDERS_LIST_PENDING = "GET_FOLDERS_LIST_PENDING";
const GET_FOLDER_CHILDREN_PENDING = "GET_FOLDER_CHILDREN_PENDING";
const GET_FOLDER_CHILDREN_SUCCESS = "GET_FOLDER_CHILDREN_SUCCESS";
const GET_FOLDER_CHILDREN_FAILURE = "GET_FOLDER_CHILDREN_FAILURE";
const GET_FOLDERS_LIST_SUCCESS = "GET_FOLDERS_LIST_SUCCESS";
const GET_FOLDERS_LIST_FAILURE = "GET_FOLDERS_LIST_FAILURE";
const GET_FOLDER_TREE_VIEW_PENDING = "GET_FOLDER_TREE_VIEW_PENDING";
const GET_FOLDER_TREE_VIEW_SUCCESS = "GET_FOLDER_TREE_VIEW_SUCCESS";
const GET_FOLDER_TREE_VIEW_FAILURE = "GET_FOLDER_TREE_VIEW_FAILURE";
const GET_DETAIL_FOLDER_PENDING = "GET_DETAIL_FOLDER_PENDING";
const GET_DETAIL_FOLDER_SUCCESS = "GET_DETAIL_FOLDER_SUCCESS";
const GET_DETAIL_FOLDER_FAILURE = "GET_DETAIL_FOLDER_FAILURE";
const GET_DRIVE_LIST_PENDING = "GET_DRIVE_LIST_PENDING";
const GET_DRIVE_LIST_SUCCESS = "GET_DRIVE_LIST_SUCCESS";
const GET_DRIVE_LIST_FAILURE = "GET_DRIVE_LIST_FAILURE";
const CREATE_FOLDER_PENDING = "CREATE_FOLDER_PENDING";
const CREATE_FOLDER_SUCCESS = "CREATE_FOLDER_SUCCESS";
const CREATE_FOLDER_FAILURE = "CREATE_FOLDER_FAILURE";
const FOLDERS_SEARCH_STATE = "FOLDERS_SEARCH_STATE";
const FOLDERS_UPDATE_STATE = "FOLDERS_UPDATE_STATE";
const UPDATE_SELECTED_FOLDER = "UPDATE_SELECTED_FOLDER";
const UPDATE_SELECTED_HISTORY = "UPDATE_SELECTED_HISTORY";
const UPDATE_FORDER_INFO_SUCCESS = "UPDATE_FORDER_INFO_SUCCESS";
const UPDATE_FORDER_INFO_PENDING = "UPDATE_FORDER_INFO_PENDING";
const UPDATE_FORDER_INFO_FAILURE = "UPDATE_FORDER_INFO_FAILURE";
const RESET_SELECTED_FOLDER = "RESET_SELECTED_FOLDER";
const DELETE_FOLDER_SUCCESS = "DELETE_FOLDER_SUCCESS";
const DELETE_FOLDER_PENDING = "DELETE_FOLDER_PENDING";
const DELETE_FOLDER_FAILURE = "DELETE_FOLDER_FAILURE";
const MOVE_FOLDER_PENDING = "MOVE_FOLDER_PENDING";
const MOVE_FOLDER_SUCCESS = "MOVE_FOLDER_SUCCESS";
const MOVE_FOLDER_FAILURE = "MOVE_FOLDER_FAILURE";
const UPDATE_MOVED_FOLDER = "UPDATE_MOVED_FOLDER";
const PUSH_FOLDER_ACTION_PENDING = "PUSH_FOLDER_ACTION_PENDING";
const CLEAR_FOLDER_ACTION_PENDING = "CLEAR_FOLDER_ACTION_PENDING";
const RESET_FOLDER_TREE_VIEW = "RESET_FOLDER_TREE_VIEW";

//reducer
const initialState = {
    pending: false,
    error: false,
    folderList: {
        loadingPosition: null,
        pending: false,
        error: null,
        data: null,
        selectedFolder: { folder: null, history: [], index: -1 },
    },
    driveList: { pending: false, data: null, error: null },
    createFolder: {
        pending: false,
        error: null,
    },
    detailFolder: {
        pending: false,
        error: null,
    },
    moveFolder: {
        folderId: null,
        pending: false,
        error: null,
    },
    //진행 중인 폴더 액션 — 드롭 시점에 등록해 액션이 끝날 때까지 유지한다.
    //등록된 동안 해당 폴더 행의 드래그·드롭이 잠기고, 대상 폴더의 조회가 커밋되면 표시 확정과 함께 소비된다
    actionPending: [], // [{ type: "move", parentId, folderId }]
    isSearch: false,
};

export default handleActions(
    {
        [RESET_FOLDER_TREE_VIEW]: (state) => {
            return { ...initialState };
        },
        [GET_FOLDER_TREE_VIEW_PENDING]: (state) => {
            return {
                ...state,
                folderList: {
                    ...state.folderList,
                    pending: true,
                    error: null,
                },
                driveList: { ...state.driveList, pending: true },
            };
        },
        [GET_FOLDER_TREE_VIEW_SUCCESS]: (state, action) => {
            return {
                ...state,
                folderList: {
                    ...state.folderList,
                    pending: false,
                    data: action.payload ?? state.folderList.data,
                },
                //전체 맵 재구성(init/search/recover) 시 위치 보정용 대기 액션은 의미를 잃으므로 폐기
                actionPending: action.payload ? [] : state.actionPending,
            };
        },
        [GET_FOLDER_TREE_VIEW_FAILURE]: (state, action) => {
            return {
                ...state,
                folderList: { ...state.folderList, pending: false, error: action.payload },
            };
        },
        [GET_DRIVE_LIST_PENDING]: (state, action) => {
            return {
                ...state,
                driveList: { ...initialState.driveList },
            };
        },
        [GET_DRIVE_LIST_SUCCESS]: (state, action) => {
            return {
                ...state,
                driveList: { ...state.driveList, data: action.payload, pending: false },
            };
        },
        [GET_DRIVE_LIST_FAILURE]: (state, action) => {
            return {
                ...state,
                driveList: { ...state.driveList, error: action.payload, pending: false },
            };
        },
        [GET_FOLDERS_LIST_PENDING]: (state) => {
            return {
                ...state,
                folderList: { ...state.folderList, error: null },
            };
        },
        [GET_FOLDER_CHILDREN_PENDING]: (state, action) => {
            const { parentId } = action.payload;
            return {
                ...state,
                folderList: {
                    ...state.folderList,
                    data: {
                        ...state.folderList.data,
                        [parentId]: {
                            ...state.folderList.data[parentId],
                            children: [],
                            pending: true,
                            isFold: false,
                        },
                    },
                },
            };
        },
        [GET_FOLDER_CHILDREN_SUCCESS]: (state, action) => {
            return {
                ...state,
                folderList: { ...state.folderList, data: action.payload },
            };
        },
        [GET_FOLDER_CHILDREN_FAILURE]: (state, action) => {
            const { parentId, isCanceled } = action.payload;
            const folder = state.folderList.data?.[parentId];
            //이미 상위 재조회 등이 이 드레인을 무효화했으면 손대지 않는다
            if (!folder?.pending) return state;
            return {
                ...state,
                folderList: {
                    ...state.folderList,
                    data: {
                        ...state.folderList.data,
                        //실패만 접힘으로 복귀시켜 재펼침(재조회)이 가능하게 함 — 취소는 상위가 정한 상태를 유지
                        [parentId]: { ...folder, pending: false, isFold: isCanceled ? folder.isFold : true },
                    },
                },
            };
        },
        [GET_FOLDERS_LIST_SUCCESS]: (state, action) => {
            return {
                ...state,
                folderList: { ...state.folderList, pending: false },
            };
        },
        [GET_FOLDERS_LIST_FAILURE]: (state, action) => {
            return {
                ...state,
                folderList: { ...state.folderList, pending: false, error: action.payload },
            };
        },
        [FOLDERS_UPDATE_STATE]: (state, action) => {
            return {
                ...state,
                folderList: {
                    ...state.folderList,
                    data: { ...state.folderList.data, ...action.payload },
                },
            };
        },
        [UPDATE_SELECTED_FOLDER]: (state, action) => {
            const selectedFolder = state.folderList.selectedFolder;
            let newSelectedHistory = [...selectedFolder.history];
            let newSelectedIndex = selectedFolder.index;

            if (selectedFolder.index < selectedFolder.history.length) {
                //이전 히스토리 도중 새로운 폴더 탐색
                newSelectedHistory = selectedFolder.history.slice(0, newSelectedIndex + 1);
            }
            newSelectedHistory.push(action.payload);
            newSelectedIndex = newSelectedIndex + 1;

            return {
                ...state,
                folderList: {
                    ...state.folderList,
                    selectedFolder: {
                        folder: action.payload,
                        history: newSelectedHistory,
                        index: newSelectedIndex,
                    },
                },
            };
        },
        [RESET_SELECTED_FOLDER]: (state, action) => {
            return {
                ...state,
                folderList: { ...state.folderList, selectedFolder: { folder: null, history: [], index: -1 } },
            };
        },
        [UPDATE_SELECTED_HISTORY]: (state, action) => {
            return {
                ...state,
                folderList: {
                    ...state.folderList,
                    selectedFolder: {
                        ...state.folderList.selectedFolder,
                        folder: state.folderList.selectedFolder.history[
                            state.folderList.selectedFolder.index + action.payload
                        ],
                        index: state.folderList.selectedFolder.index + action.payload,
                    },
                },
            };
        },
        [GET_DETAIL_FOLDER_PENDING]: (state, action) => {
            return {
                ...state,
                detailFolder: {
                    pending: true,
                    error: null,
                },
            };
        },
        [GET_DETAIL_FOLDER_SUCCESS]: (state, action) => {
            return {
                ...state,
                detailFolder: {
                    pending: false,
                    error: null,
                },
            };
        },
        [GET_DETAIL_FOLDER_FAILURE]: (state, action) => {
            return {
                ...state,
                detailFolder: {
                    pending: false,
                    error: action.payload,
                },
            };
        },
        [FOLDERS_SEARCH_STATE]: (state, action) => {
            return {
                ...state,
                ...action.payload,
            };
        },
        [UPDATE_FORDER_INFO_SUCCESS]: (state, action) => {
            if (action.payload) {
                return {
                    ...state,
                    pending: false,
                    folderList: {
                        ...state.folderList,
                        selectedFolder: {
                            ...state.folderList.selectedFolder,
                            folder: {
                                ...state.folderList.selectedFolder.folder,
                                ...action.payload,
                            },
                        },
                    },
                };
            } else {
                return {
                    ...state,
                    pending: false,
                };
            }
        },
        [UPDATE_FORDER_INFO_PENDING]: (state, action) => {
            return {
                ...state,
                pending: true,
            };
        },
        [UPDATE_FORDER_INFO_FAILURE]: (state, action) => {
            return {
                ...state,
                pending: false,
                error: action.payload,
            };
        },
        [DELETE_FOLDER_SUCCESS]: (state, action) => {
            return {
                ...state,
                pending: false,
            };
        },
        [DELETE_FOLDER_PENDING]: (state, action) => {
            return {
                ...state,
                pending: true,
            };
        },
        [DELETE_FOLDER_FAILURE]: (state, action) => {
            return {
                ...state,
                pending: false,
                error: action.payload,
            };
        },
        [MOVE_FOLDER_SUCCESS]: (state, action) => {
            return {
                ...state,
                moveFolder: {
                    folderId: null,
                    pending: false,
                },
            };
        },
        [MOVE_FOLDER_PENDING]: (state, action) => {
            return {
                ...state,
                moveFolder: {
                    folderId: action.payload,
                    pending: true,
                },
            };
        },
        [MOVE_FOLDER_FAILURE]: (state, action) => {
            return {
                ...state,
                moveFolder: {
                    error: action.payload,
                    pending: false,
                },
                pending: false,
            };
        },
        [UPDATE_MOVED_FOLDER]: (state, action) => {
            return {
                ...state,
                folderList: { ...state.folderList, data: action.payload },
            };
        },
        [PUSH_FOLDER_ACTION_PENDING]: (state, action) => {
            return {
                ...state,
                actionPending: [...state.actionPending, action.payload],
            };
        },
        [CLEAR_FOLDER_ACTION_PENDING]: (state, action) => {
            const { parentId, folderId } = action.payload;
            return {
                ...state,
                //folderId: 해당 폴더의 액션만 종료 / parentId: 그 부모의 대기 건을 조회 커밋이 일괄 소비
                actionPending: state.actionPending.filter((entry) =>
                    folderId !== undefined ? entry.folderId !== folderId : entry.parentId !== parentId,
                ),
            };
        },
    },
    initialState,
);

export const updateFolderState = createAction(FOLDERS_UPDATE_STATE);
export const updateFolderSearchState = createAction(FOLDERS_SEARCH_STATE);
export const updateSelectedFolder = createAction(UPDATE_SELECTED_FOLDER);
export const updateSelectedHistory = createAction(UPDATE_SELECTED_HISTORY);
export const resetSelectedFolder = createAction(RESET_SELECTED_FOLDER);
export const resetFolderTreeView = createAction(RESET_FOLDER_TREE_VIEW);
//DnD 이동 액션의 시작·끝. 끝은 소비 주체가 없을 때(원복·직접 삽입)만 호출하고,
//대상 조회가 소비하는 경우는 그 조회의 CLEAR가 대신 종료시킨다
export const startFolderMove = createAction(PUSH_FOLDER_ACTION_PENDING, ({ parentId, folderId }) => ({
    type: "move",
    parentId,
    folderId,
}));
export const endFolderMove = createAction(CLEAR_FOLDER_ACTION_PENDING, (folderId) => ({ folderId }));

// prevFolderMap : nextToken이 존재할 경우 폴더를 나눠서 처리할 때 이전에 이미 처리한 폴더맵
export const createFolderTree = (folderList, searchType, searchFolder, prevFolderMap) => {
    try {
        let folderMap = prevFolderMap ?? {};

        folderList.folders.map((folder, index) => {
            const parentId = folder.parent.id;
            const folderInfo = {
                isRoot: false,
                children: [],
                name: folder.name,
                type: "folder",
                isFold: true, //서치 조건
                id: folder.id,
                driveId: folderList.driveId,
                depth: folderMap?.[parentId] ? folderMap[parentId]?.depth + 1 : 0,
                parent: parentId ? parentId : folderList.rootFolder?.id,
                pending: false,
            };
            folderMap[folder.id] = folderInfo;
            if (parentId && folderMap[parentId]) {
                folderMap[parentId].children = Array.from(new Set(folderMap[parentId]?.children.concat([folder.id])));
            }
        });

        if (searchType === "search") {
            const lowerSearchFolder = String(searchFolder ?? "").toLowerCase();
            const foundFolderList = Object.values(folderMap).filter(
                (obj) => obj.isFold && (obj.name.toLowerCase().includes(lowerSearchFolder) || obj.id === searchFolder),
            );

            foundFolderList.forEach((foundFolder) => {
                if (foundFolder?.depth > 0) {
                    let parents = [foundFolder.parent]; //루트폴더

                    folderMap[foundFolder.id].isFold = false;

                    while (parents.length > 0) {
                        const id = parents.shift();

                        folderMap[id].isFold = false;
                        if (folderMap[id].depth > 0) parents.push(folderMap[id].parent);
                    }
                }
            });
        }

        return folderMap;
    } catch (error) {
        console.log(error);
    }
};

//nextToken이 없어질 때까지 전 페이지 수집. 취소 시 CanceledError를 던져 호출부 catch로 합류
const fetchAllFolders = async (endpoint, { driveId, queryParameters, headerParams, signal }) => {
    let results = [];
    let nextToken;
    do {
        const prevToken = nextToken;
        const response = await getFoldersListAPI(endpoint, {
            driveId,
            queryParameters,
            nextToken,
            headerParams,
            signal,
        });

        if (signal?.aborted) throw new axios.CanceledError();

        results = results.concat(response.data.results);
        nextToken = response.data.nextToken;
        //서버가 동일 토큰을 반복하면 무한 루프 방지
        if (nextToken && nextToken === prevToken) nextToken = undefined;
    } while (nextToken !== undefined);

    return results;
};

//createFolderTree의 search 분기(431-451)와 동작이 같지만 그쪽은 이름 검색이 쓰고 있어 손대지 않는다
const unfoldFolderPath = (folderMap, folderId) => {
    let current = folderMap[folderId];
    while (current) {
        current.isFold = false;
        current = current.depth > 0 ? folderMap[current.parent] : null;
    }
};

//409 충돌 복구 — 해당 드라이브 루트 하위를 서버 기준으로 다시 만들어 한 번에 커밋한다.
//getFoldersList는 조회와 dispatch가 한 몸이라 대상마다 커밋이 일어나 트리가 단계별로 무너져 보이므로 쓰지 않는다.
//409는 그 폴더의 현재 위치가 클라이언트 가정과 다르다는 신호라 이동 전 부모도 실패한 목적지도 실제 위치가 아니다 —
//대상 폴더 자신을 걸면 PARENT_FOLDERS가 루트→실제 부모→그 폴더 경로와 형제까지 줘 지금 있는 자리가 펼쳐진다
//@returns 선택 폴더가 갱신 결과에서 사라져 대체가 필요할 때만 대체 대상(드라이브 루트) 노드, 선택이 멀쩡하면 null
export const recoverDriveFolderTree =
    ({ driveId, movedFolderId, headerParams, signal }) =>
    async (dispatch, getState) => {
        const { stage, folderTreeView } = getState();
        const currentMap = folderTreeView.folderList.data;
        const selectedFolder = folderTreeView.folderList.selectedFolder?.folder;
        const selectedFolderId = selectedFolder?.id;
        const rootFolderId = folderTreeView.driveList.data?.find((drive) => drive.id === driveId)?.rootFolder?.id;
        if (!rootFolderId || !currentMap?.[rootFolderId]) {
            console.warn("폴더 트리 409 복구: 드라이브 루트를 찾지 못해 갱신하지 않는다", { driveId, rootFolderId });
            return null;
        }

        //다른 드라이브의 선택은 이 driveId로 조회가 성립하지 않는다 — 넣으면 그 한 건의 실패가 전체를 실패로 만든다
        const selectedTargetId = selectedFolder?.driveId === driveId ? selectedFolderId : null;
        //selectedTargetId와 movedFolderId는 겹칠 수 있으므로 Set을 사용하여 중복을 제거한다.
        const targetFolderIds = [...new Set([selectedTargetId, movedFolderId])].filter(Boolean);
        if (!targetFolderIds.length) {
            console.warn("폴더 트리 409 복구: 갱신 대상 폴더가 없다", {
                driveId,
                movedFolderId,
                selectedFolderId,
            });
            return null;
        }

        //children:[] + pending:true + isFold:false 세트라 루트 행은 이름 그대로 남고 그 아래만 스켈레톤이 된다
        dispatch({ type: GET_FOLDER_CHILDREN_PENDING, payload: { parentId: rootFolderId } });

        //PARENT_FOLDERS는 대상과 그 형제까지 주고 대상 자신의 자식은 주지 않는다.
        //이동 실패 폴더는 위치만 드러내면 되므로 자식을 받지 않는다 — 펼친 채 자식이 없으면 빈 폴더로 보이므로
        //아래에서도 그 폴더가 아니라 실제 부모까지만 펼친다. 선택 폴더는 펼쳐진 상태를 유지해야 해 자식을 받는다
        const childrenTargetIds = selectedTargetId ? [selectedTargetId] : [];

        const requests = [
            //폐기 후 재구성이라 루트에서 닿는 경로가 없으면 트리에 못 붙는다. 대상이 루트여도 그대로 건다
            ...targetFolderIds.map((id) => ({
                kind: "parent",
                id,
                queryParameters: { id, searchType: DRIVE_FOLDER_SEARCH_TYPE.PARENT_FOLDERS },
            })),
            ...childrenTargetIds.map((id) => ({
                kind: "children",
                id,
                queryParameters: { parentId: id, searchType: DRIVE_FOLDER_SEARCH_TYPE.DIRECT_CHILDREN },
            })),
        ];

        const settled = await Promise.allSettled(
            requests.map((req) =>
                fetchAllFolders(stage.endpoint, {
                    driveId,
                    queryParameters: req.queryParameters,
                    headerParams,
                    signal,
                }),
            ),
        );

        if (signal?.aborted) {
            //PENDING을 반드시 닫는다 — 남기면 getFoldersList의 pending 가드가 이후 재조회까지 막는다.
            //isCanceled:false로 루트를 접힘으로 되돌려 다시 펼치는 클릭이 재조회를 띄우게 한다
            dispatch({ type: GET_FOLDER_CHILDREN_FAILURE, payload: { parentId: rootFolderId, isCanceled: false } });
            throw new axios.CanceledError();
        }

        //토스트는 결과와 무관한 1건이라 실패 원인이 화면에 드러나지 않는다 — 어떤 조회가 왜 막혔는지 여기서만 남긴다
        const failures = settled
            .map((result, index) =>
                result.status === "rejected"
                    ? {
                          kind: requests[index].kind,
                          folderId: requests[index].id,
                          status: result.reason?.response?.status,
                          message: result.reason?.response?.data?.message ?? result.reason?.message,
                      }
                    : null,
            )
            .filter(Boolean);
        const isComplete = failures.length === 0;
        if (!isComplete) {
            console.warn("폴더 트리 409 복구: 폴더 조회에 실패해 드라이브 루트를 접은 채 복귀한다", {
                driveId,
                failures,
            });
        }

        //await 구간에 커밋된 다른 폴더의 조회·생성·삭제 결과를 되돌리지 않도록 최신 맵을 다시 읽는다
        const latestMap = getState().folderTreeView.folderList.data;
        if (!latestMap?.[rootFolderId]) {
            console.warn("폴더 트리 409 복구: 갱신 중 폴더 맵이 교체되어 커밋하지 않는다", { driveId, rootFolderId });
            return null;
        }

        const nextMap = { ...latestMap };
        Object.values(latestMap).forEach((folder) => {
            if (folder?.driveId === driveId && !folder.isRoot) delete nextMap[folder.id];
        });
        //isEmpty:false — true로 남으면 CSS가 펼침 화살표를 죽여(pointer-events:none) 재조회 수단이 사라진다
        nextMap[rootFolderId] = {
            ...latestMap[rootFolderId],
            children: [],
            isFold: !isComplete,
            isEmpty: false,
            pending: false,
        };

        if (isComplete) {
            const foldersOf = (kind, id) => {
                const index = requests.findIndex((req) => req.kind === kind && req.id === id);
                return settled[index]?.status === "fulfilled" ? settled[index].value : null;
            };

            //대상끼리 공통 조상·형제를 공유해 같은 폴더가 여러 번 담긴다. 루트(depth 0)는 응답 객체에 parent가 없어
            //createFolderTree:412에서 터지므로 제외하고, createFolderTree가 삽입 순서로 depth를 매기므로 오름차순 정렬한다
            const folderById = new Map();
            [
                ...targetFolderIds.flatMap((id) => foldersOf("parent", id)),
                ...childrenTargetIds.flatMap((id) => foldersOf("children", id)),
            ].forEach((folder) => folder.depth > 0 && folderById.set(folder.id, folder));
            const folders = [...folderById.values()].sort((a, b) => a.depth - b.depth);

            createFolderTree({ driveId, rootFolder: { id: rootFolderId }, folders }, "init", null, nextMap);

            //PARENT_FOLDERS가 대상 자신의 자식은 주지 않으므로 선택 폴더의 children·isEmpty는 여기서만 채워진다
            childrenTargetIds.forEach((id) => {
                const children = foldersOf("children", id);
                if (!nextMap[id]) return;
                nextMap[id] = {
                    ...nextMap[id],
                    children: children.map((folder) => folder.id),
                    isEmpty: children.length === 0,
                };
            });

            childrenTargetIds.forEach((id) => nextMap[id] && unfoldFolderPath(nextMap, id));
            //이동 실패 폴더는 자식을 받지 않아 펼치지 않는다 — 실제 부모까지만 펼쳐 그 폴더가 행으로 드러나게 한다
            const movedFolderParentId = nextMap[movedFolderId]?.parent;
            if (nextMap[movedFolderParentId]) unfoldFolderPath(nextMap, movedFolderParentId);
            //대상이 전부 삭제돼 붙일 게 없으면 빈 드라이브처럼 보인다 — 실패와 같게 접어 재조회를 유도한다
            if (!nextMap[rootFolderId].children.length) nextMap[rootFolderId].isFold = true;
        }

        dispatch({ type: GET_FOLDER_TREE_VIEW_SUCCESS, payload: nextMap });

        //선택 폴더가 살아남았으면 건드릴 게 없다. 대기 중 사용자가 선택을 바꿨을 수 있어 커밋 직전 값으로 판정한다
        //— 옛 id로 보면 남의 선택을 덮거나 새 선택이 방치된다. 다른 드라이브의 선택은 폐기 대상이 아니라 항상 살아남는다
        const latestSelectedId = getState().folderTreeView.folderList.selectedFolder?.folder?.id;
        if (!latestSelectedId || nextMap[latestSelectedId]) return null;

        //실패 시엔 루트 하위를 통째로 폐기했으므로 같은 드라이브의 선택은 항상 여기까지 온다.
        //호출부가 updateSelectedFolder에 그대로 넘길 수 있게 방금 커밋한 노드를 준다
        return nextMap[rootFolderId];
    };

export const getDriveData =
    ({ headerParams, domain, resourceTypeId }) =>
    async (dispatch, getState) => {
        const { stage } = getState();

        dispatch({ type: GET_DRIVE_LIST_PENDING });

        return new Promise((resolve, reject) => {
            getDrivesListAPI(stage.endpoint, { headerParams, params: { resourceTypeId } })
                .then(async (driveResponse) => {
                    dispatch({ type: GET_DRIVE_LIST_SUCCESS, payload: driveResponse.data.results });

                    let filteredDriveByDomain = driveResponse.data.results;
                    filteredDriveByDomain = driveResponse.data.results?.filter(
                        (drive) => drive.resourceType.type === domain.toUpperCase(),
                    );

                    resolve(filteredDriveByDomain);
                })
                .catch((error) => {
                    console.error(error);
                    reject(error);
                });
        });
    };

export const initFolderData =
    ({ headerParams, domain, resourceTypeId, signal }) =>
    (dispatch, getState) => {
        const { stage, project } = getState();

        dispatch({ type: GET_FOLDER_TREE_VIEW_PENDING });

        return new Promise((resolve, reject) => {
            dispatch(getDriveData({ headerParams, domain, resourceTypeId }))
                .then(async (filteredDrive) => {
                    //드라이브 별로 폴더 목록 가져오기
                    const entireFolderMap = await filteredDrive?.reduce(async (prevFolderMap, drive) => {
                        const { data: rootFolderData } = await getDetailDriveFolderAPI(stage.endpoint, {
                            driveId: drive.id,
                            folderId: drive.rootFolder.id,
                            projectId: project.id,
                        });

                        let folderMap = {
                            //이전까지의 folderMap에 현재 드라이브 정보 추가
                            ...prevFolderMap,
                            [rootFolderData.id]: {
                                isRoot: true,
                                children: [],
                                name: rootFolderData.name,
                                type: "drive",
                                isFold: false,
                                depth: 0,
                                id: rootFolderData.id,
                                driveId: drive.id,
                                parent: null,
                                pending: false,
                            },
                        };

                        const driveId = drive.id;
                        const queryParameters = {
                            parentId: drive.rootFolder.id,
                            searchType: "DIRECT_CHILDREN",
                        };

                        dispatch({ type: GET_FOLDERS_LIST_PENDING });
                        const driveInfo = {
                            rootFolder: drive.rootFolder,
                            driveId: driveId,
                            folders: await fetchAllFolders(stage.endpoint, {
                                driveId,
                                queryParameters,
                                headerParams,
                                signal,
                            }),
                        };
                        dispatch({ type: GET_FOLDERS_LIST_SUCCESS });

                        return createFolderTree(driveInfo, "init", null, folderMap);
                    }, {});

                    //중단된 요청(재조회로 대체·트리 리셋)의 결과는 폐기.
                    //단 signal을 만든 컴포넌트 기준 — TreeViewLayout과 folder-tree-view가 각자 컨트롤러를 들고 있어 서로를 취소하지 못한다
                    if (signal?.aborted) throw new axios.CanceledError();

                    dispatch({
                        type: GET_FOLDER_TREE_VIEW_SUCCESS,
                        payload: filteredDrive?.length > 0 ? entireFolderMap : undefined,
                    });
                    resolve(filteredDrive.length > 0 ? entireFolderMap[filteredDrive[0].rootFolder.id] : null); //확인
                })
                .catch((error) => {
                    if (axios.isCancel(error)) {
                        reject(error);
                        return;
                    }
                    console.log(error);
                    dispatch({ type: GET_FOLDER_TREE_VIEW_FAILURE, payload: error });
                    reject(error);
                });
        });
    };

export const getFoldersList =
    ({ driveId, queryParameters, headerParams, signal }) =>
    async (dispatch, getState) => {
        const { stage } = getState();
        const { parentId } = queryParameters;

        //해당 폴더가 이미 드레인 중이면 중복 요청하지 않음 (폴더별 독립 확장 허용)
        //이 가드로 부모당 드레인은 항상 1개 — attachMovedFolder도 드레인 중이면 대기 등록만 하고 재조회하지 않는다
        if (getState().folderTreeView.folderList.data?.[parentId]?.pending) return;

        try {
            dispatch({ type: GET_FOLDER_CHILDREN_PENDING, payload: { parentId } });

            //nextToken이 없어질 때까지 모든 페이지를 모은 뒤 한 번에 반영
            const allFolders = await fetchAllFolders(stage.endpoint, {
                driveId,
                queryParameters,
                headerParams,
                signal,
            });

            //드레인 중 트리가 리셋(페이지 이동)됐거나 부모가 사라졌으면 결과 폐기
            if (!getState().folderTreeView.folderList.data?.[parentId]) return;

            const pendingActions = getState().folderTreeView.actionPending.filter(
                (entry) => entry.parentId === parentId,
            );
            //반영 직전에 이 부모의 대기 액션을 소비 — move 커밋 전에 시작된 응답이어도 폐기하지 않고 아래에서 보정한다
            if (pendingActions.length) {
                dispatch({ type: CLEAR_FOLDER_ACTION_PENDING, payload: { parentId } });
            }

            let folderMap = Object.fromEntries(
                //기존 folderTreeView.folderList.data 그대로 사용시 삭제한 폴더의 정보가 사라지지 않음
                Object.entries(getState().folderTreeView.folderList.data),
            );

            const allFolderIds = allFolders.map((folder) => {
                folderMap[folder.id] = {
                    isRoot: false,
                    children: [],
                    name: folder.name,
                    type: "folder",
                    isFold: true,
                    id: folder.id,
                    driveId: driveId,
                    depth: folder.parent.id ? folderMap[parentId].depth + 1 : 0,
                    parent: parentId,
                    pending: false,
                };

                return folder.id;
            });

            folderMap[parentId] = {
                ...folderMap[parentId],
                children: allFolderIds,
                isFold: false,
                isEmpty: allFolderIds.length === 0,
                pending: false,
            };

            dispatch({ type: GET_FOLDER_CHILDREN_SUCCESS, payload: folderMap });

            //소비한 대기 액션 처리 — move: 커밋 전에 평가된 페이지라 응답에 빠졌으면 맨 뒤 보정 삽입 (into는 서버가 맨 뒤 배치)
            pendingActions.forEach((entry) => {
                switch (entry.type) {
                    case "move": {
                        const currentMap = getState().folderTreeView.folderList.data;
                        if (allFolderIds.includes(entry.folderId) || !currentMap?.[entry.folderId]) return;
                        //원부모가 맵에서 소실된 경우 updateMovedFolder가 children 접근에서 죽으므로 폐기
                        if (!currentMap[currentMap[entry.folderId].parent]) return;
                        dispatch(
                            updateMovedFolder({
                                fromPosition: {
                                    id: entry.folderId,
                                    parent: { id: currentMap[entry.folderId].parent },
                                },
                                toPosition: { id: parentId, parent: { id: currentMap[parentId].parent } },
                                previousId: undefined,
                            }),
                        );
                        return;
                    }
                    default:
                        return;
                }
            });
        } catch (error) {
            //드레인 종료(실패·취소) 시 이 부모의 대기 액션 정리 — 소비할 조회가 사라졌으므로 남겨둘 이유가 없다.
            //move는 이미 서버에 반영돼 다음 펼침 조회 응답에 포함되므로 표시는 자연 복구됨
            dispatch({ type: CLEAR_FOLDER_ACTION_PENDING, payload: { parentId } });
            const isCanceled = axios.isCancel(error);
            dispatch({ type: GET_FOLDER_CHILDREN_FAILURE, payload: { parentId, isCanceled } });
            if (isCanceled) return;
            console.log(error);
        }
    };

export const recoverFolderData =
    ({ headerParams, driveId, queryParameters, domain, resourceTypeId, signal }) =>
    (dispatch, getState) => {
        const { stage } = getState();

        dispatch({ type: GET_FOLDER_TREE_VIEW_PENDING });

        return new Promise((resolve, reject) => {
            dispatch(getDriveData({ headerParams, domain, resourceTypeId }))
                .then(async (filteredDrive) => {
                    let folderMap = {};
                    filteredDrive?.forEach((drive) => {
                        //이전까지의 folderMap에 현재 드라이브 정보 추가
                        folderMap[drive.rootFolder.id] = {
                            isRoot: true,
                            children: [],
                            name: drive.name,
                            type: "drive",
                            isFold: false,
                            depth: 0,
                            id: drive.rootFolder.id,
                            driveId: drive.id,
                            parent: null,
                            pending: false,
                        };
                    });

                    //PARENT_FOLDERS는 경로상 각 조상 레벨의 전체 형제 + 타깃 자신을 페이지네이션으로 반환
                    const parentFolders = await fetchAllFolders(stage.endpoint, {
                        driveId,
                        queryParameters,
                        headerParams,
                        signal,
                    });

                    const childrenFolders = await fetchAllFolders(stage.endpoint, {
                        driveId,
                        queryParameters: {
                            parentId: queryParameters.id,
                            searchType: DRIVE_FOLDER_SEARCH_TYPE.DIRECT_CHILDREN,
                        },
                        headerParams,
                        signal,
                    });

                    //createFolderTree가 삽입 순서로 depth·children을 연결하므로 부모가 항상 먼저 오도록 정렬
                    const allFolders = parentFolders.concat(childrenFolders).sort((a, b) => a.depth - b.depth);

                    if (allFolders?.length === 0) {
                        throw new Error("Requested folder is not existed.");
                    }

                    //Note: 현재 선택한 폴더의 루트폴더의 이름을 변경(기존에는 루트폴더의 id를 이름으로 가지고 있음)
                    const selectedFolderDrive = filteredDrive.find((drive) => drive.id === driveId);
                    const selectedFolderDriveRootFolder = allFolders.find(
                        (folder) => folder.id === selectedFolderDrive.rootFolder.id,
                    );
                    folderMap[selectedFolderDriveRootFolder.id].name = selectedFolderDriveRootFolder.name;

                    let driveInfo = {
                        rootFolder: {
                            id: selectedFolderDrive?.rootFolder?.id,
                        },
                        driveId: driveId,
                        folders: allFolders.filter((folder) => folder.depth > 0),
                    };

                    folderMap = createFolderTree(
                        driveInfo,
                        "search",
                        queryParameters.name ?? queryParameters.id,
                        folderMap,
                    );

                    if (queryParameters.id && !folderMap[queryParameters.id]) {
                        throw new Error("Requested folder is not existed.");
                    }

                    //중단된 요청(재조회로 대체·트리 리셋)의 결과는 폐기.
                    //단 signal을 만든 컴포넌트 기준 — TreeViewLayout과 folder-tree-view가 각자 컨트롤러를 들고 있어 서로를 취소하지 못한다
                    if (signal?.aborted) throw new axios.CanceledError();

                    dispatch({ type: GET_FOLDER_TREE_VIEW_SUCCESS, payload: folderMap });

                    resolve(folderMap[queryParameters.id]);
                })
                .catch((error) => {
                    if (axios.isCancel(error)) {
                        reject(error);
                        return;
                    }
                    console.log(error);
                    dispatch({ type: GET_FOLDER_TREE_VIEW_FAILURE, payload: error });
                    reject(error);
                });
        });
    };

export const searchFolderData =
    ({ headerParams, queryParameters, signal, domain, resourceTypeId }) =>
    (dispatch, getState) => {
        const { stage, project } = getState();

        dispatch({ type: GET_FOLDER_TREE_VIEW_PENDING });

        return new Promise((resolve, reject) => {
            dispatch(getDriveData({ headerParams, domain, resourceTypeId }))
                .then(async (filteredDrive) => {
                    //드라이브 별로 폴더 목록 가져오기
                    const entireFolderMap = await filteredDrive?.reduce(async (prevFolderMap, drive) => {
                        const { data: rootFolderData } = await getDetailDriveFolderAPI(stage.endpoint, {
                            driveId: drive.id,
                            folderId: drive.rootFolder.id,
                            projectId: project.id,
                        });

                        let folderMap = {
                            //이전까지의 folderMap에 현재 드라이브 정보 추가
                            ...prevFolderMap,
                            [rootFolderData.id]: {
                                isRoot: true,
                                children: [],
                                name: rootFolderData.name,
                                type: "drive",
                                isFold: false,
                                depth: 0,
                                id: rootFolderData.id,
                                driveId: drive.id,
                                parent: null,
                                pending: false,
                            },
                        };

                        const driveId = drive.id;
                        const driveInfo = {
                            driveId: drive.id,
                            rootFolder: drive.rootFolder,
                            folders: [],
                        };

                        try {
                            const searchedFolders = await fetchAllFolders(stage.endpoint, {
                                driveId,
                                queryParameters,
                                headerParams,
                                signal,
                            });
                            driveInfo.folders = searchedFolders.filter((folder) => folder.depth > 0);
                        } catch (error) {
                            if (axios.isCancel(error)) return folderMap;
                            throw error;
                        }

                        //중단됐으면 이 드라이브의 트리 구성은 건너뛰고 지금까지의 맵만 반환
                        if (signal?.aborted) return folderMap;

                        return createFolderTree(
                            driveInfo,
                            "search",
                            queryParameters.name ?? queryParameters.id,
                            folderMap,
                        );
                    }, {});

                    //중단된 요청의 결과는 폐기 (아래 catch에서 reject로 합류)
                    if (signal?.aborted) throw new axios.CanceledError();

                    dispatch({
                        type: GET_FOLDER_TREE_VIEW_SUCCESS,
                        payload: filteredDrive?.length > 0 ? entireFolderMap : undefined,
                    });
                    resolve(
                        queryParameters.searchType === DRIVE_FOLDER_SEARCH_TYPE.PARENT_FOLDERS
                            ? entireFolderMap[queryParameters.id]
                            : undefined,
                    );
                })
                .catch((error) => {
                    //성공 외 경로도 반드시 settle — 호출부의 await가 멈추지 않도록
                    if (axios.isCancel(error)) {
                        reject(error);
                        return;
                    }
                    console.log(error);
                    dispatch({ type: GET_FOLDER_TREE_VIEW_FAILURE, payload: error });
                    reject(error);
                });
        });
    };

export const createDriveFolder = (driveId, params) => (dispatch, getState) => {
    const { stage, project } = getState();
    dispatch({ type: CREATE_FOLDER_PENDING });
    return new Promise((resolve, reject) => {
        createDriveFolderAPI(stage.endpoint, project.id, driveId, params)
            .then((response) => {
                dispatch({ type: CREATE_FOLDER_SUCCESS, payload: response.data });
                resolve(response.data);
            })
            .catch((error) => {
                console.log(error);
                dispatch({ type: CREATE_FOLDER_FAILURE, payload: error });
                reject(error);
            });
    });
};

export const getDetailDriveFolder =
    ({ driveId, folderId }) =>
    (dispatch, getState) => {
        const { stage, project } = getState();

        dispatch({ type: GET_DETAIL_FOLDER_PENDING });
        return new Promise((resolve, reject) => {
            getDetailDriveFolderAPI(stage.endpoint, { driveId, folderId, projectId: project.id })
                .then((response) => {
                    dispatch({ type: GET_DETAIL_FOLDER_SUCCESS, payload: response.data });
                    resolve(response.data);
                })
                .catch((error) => {
                    console.trace(error);
                    dispatch({ type: GET_DETAIL_FOLDER_FAILURE, payload: error });
                    reject(error);
                });
        });
    };

export const updateFolderInfo =
    ({ driveId, folderId }, params) =>
    (dispatch, getState) => {
        const { stage, project } = getState();

        dispatch({ type: UPDATE_FORDER_INFO_PENDING });
        return new Promise((resolve, reject) => {
            setFolderInfoAPI(stage.endpoint, { driveId, folderId, projectId: project.id }, params)
                .then((response) => {
                    const isSelectedFolder = getState().folderTreeView.folderList.selectedFolder.folder.id === folderId;

                    dispatch({ type: UPDATE_FORDER_INFO_SUCCESS, payload: isSelectedFolder ? params : null });
                    resolve(response.data);
                })
                .catch((error) => {
                    console.log(error);
                    dispatch({ type: UPDATE_FORDER_INFO_FAILURE, payload: error });
                    reject(error);
                });
        });
    };

export const deleteFolder =
    ({ driveId, folderId }) =>
    (dispatch, getState) => {
        const { stage, project } = getState();

        dispatch({ type: DELETE_FOLDER_PENDING });
        return new Promise((resolve, reject) => {
            deleteFolderAPI(stage.endpoint, { driveId, folderId, projectId: project.id })
                .then((response) => {
                    dispatch({ type: DELETE_FOLDER_SUCCESS });
                    resolve(response.data);
                })
                .catch((error) => {
                    console.log(error);
                    dispatch({ type: DELETE_FOLDER_FAILURE, payload: error });
                    reject(error);
                });
        });
    };

export const moveFolder =
    ({ driveId }, params) =>
    (dispatch, getState) => {
        const { stage, project } = getState();

        dispatch({ type: MOVE_FOLDER_PENDING, payload: params.from.id });
        return new Promise((resolve, reject) => {
            moveFolderAPI(stage.endpoint, { driveId, projectId: project.id }, params)
                .then((response) => {
                    dispatch({ type: MOVE_FOLDER_SUCCESS });
                    resolve(response);
                })
                .catch((error) => {
                    console.log(error);
                    dispatch({ type: MOVE_FOLDER_FAILURE, payload: error });
                    reject(error);
                });
        });
    };

export const updateMovedFolder =
    ({ fromPosition, toPosition, previousId }) =>
    (dispatch, getState) => {
        // fromPosition과 toPosition이 동일한 경우 처리하지 않고 종료
        if (fromPosition.id === toPosition.id) {
            return;
        }

        const { folderTreeView } = getState();

        let folderMap = {
            ...folderTreeView.folderList.data,
        };

        let fromObj = {
            ...folderMap[fromPosition.parent.id],
            children: folderMap[fromPosition.parent.id].children?.filter((id) => id !== fromPosition.id),
        };

        folderMap[fromPosition.parent.id] = fromObj;
        if (folderMap[toPosition.id]) {
            folderMap[fromPosition.id].parent = toPosition.id;
            folderMap[fromPosition.id].depth = folderMap[toPosition.id].depth + 1;
            let children = [...folderMap[fromPosition.id].children];
            while (children?.length) {
                //Note: 이동중인 폴더 자식들의 정보 업데이트
                const child = folderMap[children.shift()];

                child.depth = folderMap[child.parent].depth + 1;
                if (!child.isFold && child.children?.length) {
                    children = children.concat([...child.children]);
                }
            }
            let parent = folderMap[toPosition.id]; //부모들 중 접혀있는 폴더 강제로 펴기
            while (parent) {
                parent.isFold = false;
                parent = folderMap[parent.parent];
            }
            // previousId — undefined: 맨 뒤(기존 호환) / null: 맨 앞 / ID: 해당 폴더 바로 뒤 (folders:move position 시맨틱)
            const siblings = folderMap[toPosition.id].children;
            if (previousId === undefined) {
                siblings.push(fromPosition.id);
            } else if (previousId === null) {
                siblings.unshift(fromPosition.id);
            } else {
                const prevIndex = siblings.indexOf(previousId);
                // 응답 대기 중 목록 갱신 등으로 previousId가 없으면 맨 뒤로 (서버 기본 배치와 동일)
                if (prevIndex === -1) {
                    siblings.push(fromPosition.id);
                } else {
                    siblings.splice(prevIndex + 1, 0, fromPosition.id);
                }
            }
        } else {
            delete folderMap[fromPosition.id];
        }

        dispatch({ type: UPDATE_MOVED_FOLDER, payload: folderMap });
    };

// 이동 폴더를 원부모 children에서만 제거 — 접힌 대상으로의 지연 표시 흐름용 (대상에는 삽입하지 않고 attachMovedFolder로 표시)
// 이동 폴더의 map 엔트리는 유지해 move 실패 시 원위치 복원이 가능하게 함
export const detachMovedFolder =
    ({ folderId }) =>
    (dispatch, getState) => {
        const folderMap = { ...getState().folderTreeView.folderList.data };
        const parent = folderMap[folderMap[folderId]?.parent];
        if (!parent) return;
        const children = parent.children?.filter((id) => id !== folderId) ?? [];
        folderMap[parent.id] = { ...parent, children, isEmpty: children.length === 0 };
        dispatch({ type: UPDATE_MOVED_FOLDER, payload: folderMap });
    };

// detach된 이동 폴더를 대상에 반영 — move API 성공 후 호출.
// 대기 액션은 드롭 시점에 이미 등록돼 있으므로 여기서는 그 엔트리를 누가 소비할지만 정한다:
// 로드 완료 → 직접 삽입 후 액션 종료 / 드레인 중 → 진행 중 조회에 위임 / 접힘 → 조회를 띄워 위임
// 판정은 move 응답 시점의 최신 상태 기준 (드롭 핸들러의 클로저는 드롭 시점 스냅샷이라 사용 불가)
export const attachMovedFolder =
    ({ driveId, folderId, parentId, headerParams, signal }) =>
    async (dispatch, getState) => {
        const folderMap = getState().folderTreeView.folderList.data;
        const toParent = folderMap?.[parentId];
        const folder = folderMap?.[folderId];
        //대상이나 이동 폴더가 맵에서 사라졌으면 소비할 주체가 없으므로 액션만 종료
        if (!toParent || !folder) {
            dispatch({ type: CLEAR_FOLDER_ACTION_PENDING, payload: { folderId } });
            return;
        }

        //드롭 시점엔 접힘·드레인 중이었지만 move 응답 대기 중 로드가 끝난 경우
        if (!toParent.pending && !toParent.isFold) {
            //그 조회가 이미 이동 폴더를 반영했으면 중복 삽입 방지
            if (!toParent.children?.includes(folderId)) {
                dispatch(
                    updateMovedFolder({
                        fromPosition: { id: folderId, parent: { id: folder.parent } },
                        toPosition: { id: parentId, parent: { id: toParent.parent } },
                        previousId: undefined,
                    }),
                );
            }
            dispatch({ type: CLEAR_FOLDER_ACTION_PENDING, payload: { folderId } });
            return;
        }

        //드레인 중이면 그 응답이 대기 액션을 소비해 표시 확정과 잠금 해제를 함께 처리한다 —
        //재조회하면 거의 끝난 작업을 버리고 처음부터 다시 받게 된다
        if (toParent.pending) return;

        //접힘 — 소비할 조회가 없으므로 여기서 조회를 띄워 펼침과 표시를 함께 처리 (move 이후 시작이라 응답에 포함 보장)
        await dispatch(
            getFoldersList({
                driveId,
                queryParameters: { parentId, searchType: DRIVE_FOLDER_SEARCH_TYPE.DIRECT_CHILDREN },
                headerParams,
                signal,
            }),
        );
    };
